module.exports = __webpack_public_path__ + "src/assets/games/42/261.jpg";